import { render, staticRenderFns } from "./TradesTable.vue?vue&type=template&id=a76624b0&"
import script from "./TradesTable.vue?vue&type=script&lang=js&"
export * from "./TradesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports